import { AdacHeadline } from '@adac-de/component-library';
import React from 'react';
import { clsx } from 'clsx';
import styles from './benefits-box.module.scss';
import { Icon } from '@components/icons/icons';
import { CloudinaryImage } from '@components/cloudinary-image/cloudinary-image';
import { removeContentfulVehicleStrings } from '@utils/remove-contentful-vehicle-strings';
import { replaceContentfulPlaceholder } from '@utils/replace-contentful-placeholder';
import { useIsBreakpoint } from '@hooks/use-is-breakpoint';
import { Breakpoints } from '@utils/breakpoints';
import { List } from '@components/list/list';

type BenefitsBoxProps = {
  benefits: {
    headline: string;
    listItem: string[];
    image?: CloudinaryImageFragment;
  };
  roundedValues: PvWizardResultSectionOffer['values'];
  hasVehicle: Boolean;
};

export const BenefitsBox: React.FC<BenefitsBoxProps> = ({
  benefits,
  hasVehicle,
  roundedValues
}) => {
  const isDesktop = useIsBreakpoint(Breakpoints.S);
  const filteredBenefitsList = hasVehicle
    ? benefits.listItem
    : removeContentfulVehicleStrings(benefits.listItem);
  const listItems = filteredBenefitsList.map(listItem =>
    replaceContentfulPlaceholder({
      content: listItem,
      values: roundedValues
    })
  );

  return (
    <div className={clsx({ [styles.benefits]: true, [styles.desktopGrid]: benefits?.image })}>
      <div>
        <div className={clsx('margin-bottom--m', styles.iconHeadline)}>
          <div className={styles.savingsIcon}>
            <Icon.Savings />
          </div>
          <AdacHeadline styleAs="h3slab" tagName="h3">
            {benefits.headline}
          </AdacHeadline>
        </div>
        <List listItems={listItems} />
      </div>
      {benefits?.image && isDesktop && <CloudinaryImage {...benefits?.image} />}
    </div>
  );
};
